import WidgetIcon1 from "../Assets/svgs/WidgetIcon/WidgetIcon1";
import WidgetIcon2 from "../Assets/svgs/WidgetIcon/WidgetIcon2";
import WidgetIcon3 from "../Assets/svgs/WidgetIcon/WidgetIcon3";
import WidgetIcon4 from "../Assets/svgs/WidgetIcon/WidgetIcon4";
import WidgetIcon5 from "../Assets/svgs/WidgetIcon/WidgetIcon5";
import WidgetIcon6 from "../Assets/svgs/WidgetIcon/WidgetIcon6";
import { uuidGenerator } from "./utils";

export const LIMIT_PER_PAGE = 20;

export const subscriptionType = [
  { label: "Annually", value: 365 },
  { label: "Monthly", value: 30 },
];

export const transcriberModel = [
  "gpt-4o-mini",
  "gpt-4o-mini-2024-07-18",
  "gpt-4o",
  "gpt-4o-2024-05-13",
  "gpt-4o-2024-08-06",
  "gpt-4-turbo",
  "gpt-4-turbo-2024-04-09",
  "gpt-4-turbo-preview",
  "gpt-4-0125-preview",
  "gpt-4-1106-preview",
  "gpt-4",
  "gpt-4-0613",
  "gpt-3.5-turbo",
  "gpt-3.5-turbo-0125",
  "gpt-3.5-turbo-1106",
  "gpt-3.5-turbo-16k",
  "gpt-3.5-turbo-0613",
];

// export const TranscriberLanguage = [
//   "bg", "ca", 'cs', 'da', 'da-DK', 'de', 'de-CH', 'el', 'en', 'en-AU', 'en-GB', 'en-IN', 'en-NZ',' en-US', 'es', 'es-419',
//    ];

export const TranscriberLanguage = [
  "en",
  "en-AU",
  "en-GB",
  "en-IN",
  "en-NZ",
  "en-US",
  ,
];

// export  const Voice = [
//   "burt", "marissa", "andrea", "sarah", "phillip", "steve", "joseph", "myra", "paula", "ryan", "drew", "paul", "mrb", "matilda", "mark"
// ]

export const AzureVoices = ["andrew", "brian", "emma"];

export const DeepGramTranscriberLanguage = [
  "bg",
  "ca",
  "cs",
  "da",
  "da-DK",
  "de",
  "de-CH",
  "el",
  "en",
  "en-AU",
  "en-GB",
  "en-IN",
  "en-NZ",
  "en-US",
  "es",
  "es-419",
  "es-LATAM",
  "et",
  "fi",
  "fr",
  "fr-CA",
  "hi",
  "hi-Latn",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "ko-KR",
  "lt",
  "lv",
  "ms",
  "multi",
  "nl",
  "nl-BE",
  "no",
  "pl",
  "pt",
  "pt-BR",
  "ro",
  "ru",
  "sk",
  "sv",
  "sv-SE",
  "ta",
  "taq",
  "th",
  "th-TH",
  "tr",
  "uk",
  "vi",
  "zh",
  "zh-CN",
  "zh-Hans",
  "zh-Hant",
  "zh-TW",
];

export const GladiaTranscriberLanguage = [
  "af",
  "sq",
  "am",
  "ar",
  "hy",
  "as",
  "az",
  "ba",
  "eu",
  "be",
  "bn",
  "bs",
  "br",
  "bg",
  "ca",
  "zh",
  "hr",
  "cs",
  "da",
  "nl",
  "en",
  "et",
  "fo",
  "fi",
  "fr",
  "gl",
  "ka",
  "de",
  "el",
  "gu",
  "ht",
  "ha",
  "haw",
  "he",
  "hi",
  "hu",
  "is",
  "id",
  "it",
  "ja",
  "jp",
  "jv",
  "kn",
  "kk",
  "km",
  "ko",
  "lo",
  "la",
  "lv",
  "ln",
  "lt",
  "lb",
  "mk",
  "mg",
  "ms",
  "ml",
  "mt",
  "mi",
  "mr",
  "mn",
  "mymr",
  "ne",
  "no",
  "nn",
  "oc",
  "ps",
  "fa",
  "pl",
  "pt",
  "pa",
  "ro",
  "ru",
  "sa",
  "sr",
  "sn",
  "sd",
  "si",
  "sk",
  "sl",
  "so",
  "es",
  "su",
  "sw",
  "sv",
  "tl",
  "tg",
  "ta",
  "tt",
  "te",
  "th",
  "bo",
  "tr",
  "tk",
  "uk",
  "ur",
  "uz",
  "vi",
  "cy",
  "yi",
  "yo",
];

const TalkScriberLanguage = [
  "en",
  "zh",
  "de",
  "es",
  "ru",
  "ko",
  "fr",
  "ja",
  "pt",
  "tr",
  "pl",
  "ca",
  "nl",
  "ar",
  "sv",
  "it",
  "id",
  "hi",
  "fi",
  "vi",
  "he",
  "uk",
  "el",
  "ms",
  "cs",
  "ro",
  "da",
  "hu",
  "ta",
  "no",
  "th",
  "ur",
  "hr",
  "bg",
  "lt",
  "la",
  "mi",
  "ml",
  "cy",
  "sk",
  "te",
  "fa",
  "lv",
  "bn",
  "sr",
  "az",
  "sl",
  "kn",
  "et",
  "mk",
  "br",
  "eu",
  "is",
  "hy",
  "ne",
  "mn",
  "bs",
  "kk",
  "sq",
  "sw",
  "gl",
  "mr",
  "pa",
  "si",
  "km",
  "sn",
  "yo",
  "so",
  "af",
  "oc",
  "ka",
  "be",
  "tg",
  "sd",
  "gu",
  "am",
  "yi",
  "lo",
  "uz",
  "fo",
  "ht",
  "ps",
  "tk",
  "nn",
  "mt",
  "sa",
  "lb",
  "my",
  "bo",
  "tl",
  "mg",
  "as",
  "tt",
  "haw",
  "ln",
  "ha",
  "ba",
  "jw",
  "su",
  "yue",
];

export const nova2AiLanguage = [
  "bg",
  "ca",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-Hans",
  "zh-TW",
  "zh-Hant",
  "cs",
  "da",
  "da-DK",
  "nl",
  "en",
  "en-US",
  "en-AU",
  "en-GB",
  "en-NZ",
  "en-IN",
  "et",
  "fi",
  "nl-BE",
  "fr",
  "fr-CA",
  "de",
  "de-CH",
  "el",
  "hi",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "ko-KR",
  "lv",
  "lt",
  "ms",
  "multi",
  "no",
  "pl",
  "pt",
  "pt-BR",
  "ro",
  "ru",
  "sk",
  "es",
  "es-419",
  "sv",
  "sv-SE",
  "th",
  "th-TH",
  "tr",
  "uk",
  "vi",
];

export const nova2GeneralAiLanguage = [
  "bg",
  "ca",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-Hans",
  "zh-TW",
  "zh-Hant",
  "cs",
  "da",
  "da-DK",
  "nl",
  "en",
  "en-US",
  "en-AU",
  "en-GB",
  "en-NZ",
  "en-IN",
  "et",
  "fi",
  "nl-BE",
  "fr",
  "fr-CA",
  "de",
  "de-CH",
  "el",
  "hi",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "ko-KR",
  "lv",
  "lt",
  "ms",
  "multi",
  "no",
  "pl",
  "pt",
  "pt-BR",
  "ro",
  "ru",
  "sk",
  "es",
  "es-419",
  "sv",
  "sv-SE",
  "th",
  "th-TH",
  "tr",
  "uk",
  "vi",
];

export const novaConversationalAiLanguage = ["en", "en-US"];

export const novaGeneralAiLanguage = [
  "en",
  "en-US",
  "en-AU",
  "en-GB",
  "en-NZ",
  "en-IN",
  "es",
  "es-419",
];

export const novaBaseAiLanguage = [
  "zh",
  "zh-CN",
  "zh-TW",
  "da",
  "nl",
  "en",
  "en-US",
  "fr",
  "fr-CA",
  "de",
  "hi",
  "hi-Latn",
  "id",
  "it",
  "ja",
  "ko",
  "no",
  "pl",
  "pt",
  "pt-BR",
  "ru",
  "es",
  "es-419",
  "es-LATAM",
  "sv",
  "taq",
  "tr",
  "uk",
];

export const novaEnhancedAiLanguage = [
  "da",
  "nl",
  "en",
  "en-US",
  "fr",
  "de",
  "hi",
  "it",
  "ja",
  "ko",
  "no",
  "pl",
  "pt",
  "pt-BR",
  "es",
  "es-419",
  "es-LATAM",
  "sv",
  "taq",
  "ta",
];

export const Voice = [
  "angus",
  "arcas",
  "asteria",
  "athena",
  "hera",
  "helios",
  "luna",
  "orion",
  "orpheus",
  "perseus",
  "stella",
  "zeus",
];

export const backgroundSound = ["off", "office"];

export const provider = [
  "anyscale",
  "anthropic",
  "azure-openai",
  "custom-llm",
  "deepinfra",
  "groq",
  "openai",
  "openrouter",
  "perplexity-ai",
  "runpod",
  "together-ai",
  "vapi",
];

export const transcriberProvider = ["deepgram", "gladia", "talkscriber"];

export const functionType = [
  "dtmf",
  "endCall",
  "function",
  "ghl",
  "make",
  "output",
  "transferCall",
  "voicemail",
];

export const CONTACT_MEMBERS_COLOUMS = [
  {
    label: "First Name",
    key: "firstName",
    avatarKey: "avatar",
    className: "profile",
  },
  {
    label: "Last Name",
    key: "lastName",
    className: "cellText",
  },
  {
    label: "Email",
    key: "email",
    className: "cellText",
  },
  {
    label: "Phone Number",
    key: "phoneNumber",
    className: "cellText",
  },
];

export const IdleMessagesData = [
  {
    label: "Are you still there?",
    value: "Are you still there?",
  },
  {
    label: "Is there anything else you need help with?",
    value: "Is there anything else you need help with?",
  },
  {
    label: "Feel free to ask me any questions.",
    value: "Feel free to ask me any questions.",
  },
  {
    label: "How can I assist you further?",
    value: "How can I assist you further?",
  },
  {
    label: "Let me know if there's anything you need.",
    value: "Let me know if there's anything you need.",
  },
  {
    label: "I'm ready to help whenever you are.",
    value: "I'm ready to help whenever you are.",
  },
  {
    label: "Is there something specific you're looking for?",
    value: "Is there something specific you're looking for?",
  },
  {
    label: "I'm here to help with any questions you have.",
    value: "I'm here to help with any questions you have.",
  },
];

export const INITIAL_CONTACT_FILTER_STATE = {
  isActive: null,
};

export const INITIAL_FILE_TYPES = [
  {
    label: "txt",
    value: "txt",
  },
  {
    label: "pdf",
    value: "pdf",
  },
  {
    label: "doc",
    value: "doc",
  },
  {
    label: "docx",
    value: "docx",
  },
  {
    label: "csv",
    value: "csv",
  },
  {
    label: "xlsx",
    value: "xlsx",
  },
];

export const WIDGET_POSITION = Object.freeze({
  TOP_RIGHT: "top-right",
  TOP_MID: "top-mid",
  TOP_LEFT: "top-left",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_MID: "bottom-mid",
  BOTTOM_RIGHT: "bottom-right",
  MID_LEFT: "mid-left",
  MID_RIGHT: "mid-right",
});

export const ALL_OPENAI_PROVIDERS = [
  {
    label: "gpt-4o-realtime-preview-2024-10-01",
    value: "gpt-4o-realtime-preview-2024-10-01",
  },
  {
    label: "gpt-4o-mini",
    value: "gpt-4o-mini",
  },
  {
    label: "gpt-4o-mini-2024-07-18",
    value: "gpt-4o-mini-2024-07-18",
  },
  {
    label: "gpt-4o",
    value: "gpt-4o",
  },
  {
    label: "gpt-4o-2024-05-13",
    value: "gpt-4o-2024-05-13",
  },
  {
    label: "gpt-4o-2024-08-06",
    value: "gpt-4o-2024-08-06",
  },
  {
    label: "gpt-4o-2024-11-20",
    value: "gpt-4o-2024-11-20",
  },
  {
    label: "gpt-4-turbo",
    value: "gpt-4-turbo",
  },
  {
    label: "gpt-4-turbo-2024-04-09",
    value: "gpt-4-turbo-2024-04-09",
  },
  {
    label: "gpt-4-turbo-preview",
    value: "gpt-4-turbo-preview",
  },
  {
    label: "gpt-4-0125-preview",
    value: "gpt-4-0125-preview",
  },
  {
    label: "gpt-4-1106-preview",
    value: "gpt-4-1106-preview",
  },
  {
    label: "gpt-4",
    value: "gpt-4",
  },
  {
    label: "gpt-4-0613",
    value: "gpt-4-0613",
  },
  {
    label: "gpt-3.5-turbo",
    value: "gpt-3.5-turbo",
  },
  {
    label: "gpt-3.5-turbo-0125",
    value: "gpt-3.5-turbo-0125",
  },
  {
    label: "gpt-3.5-turbo-1106",
    value: "gpt-3.5-turbo-1106",
  },
  {
    label: "gpt-3.5-turbo-16k",
    value: "gpt-3.5-turbo-16k",
  },
  {
    label: "gpt-3.5-turbo-0613",
    value: "gpt-3.5-turbo-0613",
  },
];

export const ALL_ASSISTANT_LLM_PROVIDER = [
  {
    label: "Anyscale",
    value: "anyscale",
    models: [
      {
        label: "gpt-3.5-turbo",
        value: "gpt-3.5-turbo",
      },
    ],
  },
  {
    label: "Anthropic",
    value: "anthropic",
    models: [
      {
        label: "claude-3-opus-20240229",
        value: "claude-3-opus-20240229",
      },
      {
        label: "claude-3-sonnet-20240229",
        value: "claude-3-sonnet-20240229",
      },
      {
        label: "claude-3-haiku-20240307",
        value: "claude-3-haiku-20240307",
      },
      {
        label: "claude-3-5-sonnet-20240620",
        value: "claude-3-5-sonnet-20240620",
      },
      {
        label: "claude-3-5-sonnet-20241022",
        value: "claude-3-5-sonnet-20241022",
      },
      {
        label: "claude-3-5-haiku-20241022",
        value: "claude-3-5-haiku-20241022",
      },
    ],
  },
  {
    label: "Deepinfra",
    value: "deepinfra",
    models: [
      {
        label: "gpt-3.5-turbo",
        value: "gpt-3.5-turbo",
      },
    ],
  },
  {
    label: "Google",
    value: "google",
    models: [
      {
        label: "gemini-1.5-flash",
        value: "gemini-1.5-flash",
      },
      {
        label: "gemini-1.5-flash-002",
        value: "gemini-1.5-flash-002",
      },
      {
        label: "gemini-1.5-pro",
        value: "gemini-1.5-pro",
      },
      {
        label: "gemini-1.5-pro-002",
        value: "gemini-1.5-pro-002",
      },
      {
        label: "gemini-1.0-pro",
        value: "gemini-1.0-pro",
      },
    ],
  },
  {
    label: "Groq",
    value: "groq",
    models: [
      {
        label: "llama-3.1-405b-reasoning",
        value: "llama-3.1-405b-reasoning",
      },
      {
        label: "llama-3.1-70b-versatile",
        value: "llama-3.1-70b-versatile",
      },
      {
        label: "llama-3.1-8b-instant",
        value: "llama-3.1-8b-instant",
      },
      {
        label: "mixtral-8x7b-32768",
        value: "mixtral-8x7b-32768",
      },
      {
        label: "llama3-8b-8192",
        value: "llama3-8b-8192",
      },
      {
        label: "llama3-70b-8192",
        value: "llama3-70b-8192",
      },
      {
        label: "llama3-groq-8b-8192-tool-use-preview",
        value: "llama3-groq-8b-8192-tool-use-preview",
      },
      {
        label: "llama3-groq-70b-8192-tool-use-preview",
        value: "llama3-groq-70b-8192-tool-use-preview",
      },
      {
        label: "gemma-7b-it",
        value: "gemma-7b-it",
      },
      {
        label: "gemma2-9b-it",
        value: "gemma2-9b-it",
      },
    ],
  },
  {
    label: "Inflection AI",
    value: "inflection-ai",
    models: [
      {
        label: "inflection_3_pi",
        value: "inflection_3_pi",
      },
    ],
  },
  {
    label: "Openai",
    value: "openai",
    models: ALL_OPENAI_PROVIDERS,
  },
  {
    label: "Openrouter",
    value: "openrouter",
    models: [
      {
        label: "gpt-3.5-turbo",
        value: "gpt-3.5-turbo",
      },
    ],
  },
  {
    label: "Perplexity AI",
    value: "perplexity-ai",
    models: [
      {
        label: "gpt-3.5-turbo",
        value: "gpt-3.5-turbo",
      },
    ],
  },
  {
    label: "Xai",
    value: "xai",
    models: [
      {
        label: "grok-beta",
        value: "grok-beta",
      },
    ],
  },
  {
    label: "Deep Seek",
    value: "deep-seek",
    models: [
      {
        label: "deepseek-chat",
        value: "deepseek-chat",
      },
      {
        label: "deepseek-reasoner",
        value: "deepseek-reasoner",
      },
    ],
  },
];

export const ALL_TRANSCRIBER_PROVIDERS = [
  {
    label: "Assembly AI",
    value: "assembly-ai",
    models: [],
    languages: ["en"],
  },
  {
    label: "Deepgram",
    value: "deepgram",
    models: [
      {
        label: "nova-3",
        value: "nova-3",
        languages: novaConversationalAiLanguage,
      },
      { label: "nova-2", value: "nova-2", languages: nova2AiLanguage },
      {
        label: "nova-2-general",
        value: "nova-2-general",
        languages: nova2GeneralAiLanguage,
      },
      {
        label: "nova-2-meeting",
        value: "nova-2-meeting",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova-2-phonecall",
        value: "nova-2-phonecall",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova-2-finance",
        value: "nova-2-finance",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova-2-conversationalai",
        value: "nova-2-conversationalai",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova-2-voicemail",
        value: "nova-2-voicemail",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova-2-video",
        value: "nova-2-video",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova-2-medical",
        value: "nova-2-medical",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova-2-drivethru",
        value: "nova-2-drivethru",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova-2-automotive",
        value: "nova-2-automotive",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova",
        value: "nova",
        languages: novaGeneralAiLanguage,
      },
      {
        label: "nova-general",
        value: "nova-general",
        languages: novaGeneralAiLanguage,
      },
      {
        label: "nova-phonecall",
        value: "nova-phonecall",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "nova-medical",
        value: "nova-medical",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "enhanced",
        value: "enhanced",
        languages: novaEnhancedAiLanguage,
      },
      {
        label: "enhanced-general",
        value: "enhanced-general",
        languages: novaEnhancedAiLanguage,
      },
      {
        label: "enhanced-meeting",
        value: "enhanced-meeting",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "enhanced-phonecall",
        value: "enhanced-phonecall",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "enhanced-finance",
        value: "enhanced-finance",
        languages: novaConversationalAiLanguage,
      },
      { label: "base", value: "base", languages: novaBaseAiLanguage },
      {
        label: "base-general",
        value: "base-general",
        languages: novaBaseAiLanguage,
      },
      {
        label: "base-meeting",
        value: "base-meeting",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "base-phonecall",
        value: "base-phonecall",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "base-finance",
        value: "base-finance",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "base-conversationalai",
        value: "base-conversationalai",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "base-voicemail",
        value: "base-voicemail",
        languages: novaConversationalAiLanguage,
      },
      {
        label: "base-video",
        value: "base-video",
        languages: novaConversationalAiLanguage,
      },
    ],
    languages: DeepGramTranscriberLanguage,
  },
  {
    label: "Gladia",
    value: "gladia",
    models: [
      { label: "fast", value: "fast" },
      { label: "accurate", value: "accurate" },
    ],
    languages: GladiaTranscriberLanguage,
  },
  {
    label: "Talkscriber",
    value: "talkscriber",
    models: [{ label: "whisper", value: "whisper" }],
    languages: TalkScriberLanguage,
  },
];

export const ALL_VOICE_PROVIDERS = [
  {
    label: "Azure",
    value: "azure",
    isSpeed: true,
    voiceId: [
      { label: "andrew", value: "andrew" },
      { label: "brian", value: "brian" },
      { label: "emma", value: "emma" },
      { label: "Natasha Neural", value: "en-AU-NatashaNeural" },
      { label: "William Neural", value: "en-AU-WilliamNeural" },
    ],
  },

  {
    label: "Deepgram",
    value: "deepgram",
    isSpeed: false,
    voiceId: [
      { label: "asteria", value: "asteria" },
      { label: "luna", value: "luna" },
      { label: "stella", value: "stella" },
      { label: "athena", value: "athena" },
      { label: "hera", value: "hera" },
      { label: "orion", value: "orion" },
      { label: "arcas", value: "arcas" },
      { label: "perseus", value: "perseus" },
      { label: "angus", value: "angus" },
      { label: "orpheus", value: "orpheus" },
      { label: "helios", value: "helios" },
      { label: "zeus", value: "zeus" },
    ],
  },
  {
    label: "11labs",
    value: "11labs",
    isSpeed: false,
    voiceId: [
      { label: "burt", value: "burt" },
      { label: "marissa", value: "marissa" },
      { label: "andrea", value: "andrea" },
      { label: "sarah", value: "sarah" },
      { label: "phillip", value: "phillip" },
      { label: "steve", value: "steve" },
      { label: "joseph", value: "joseph" },
      { label: "myra", value: "myra" },
      { label: "paula", value: "paula" },
      { label: "ryan", value: "ryan" },
      { label: "drew", value: "drew" },
      { label: "paul", value: "paul" },
      { label: "mrb", value: "mrb" },
      { label: "matilda", value: "matilda" },
      { label: "mark", value: "mark" },

      { label: "Mark (US)", value: "1SM7GgM6IMuvQlz2BwM3" },
      { label: "Alex Ozwyn (US)", value: "ZncGbt9ecxkwpmaX6V9z" },
      { label: "Jeff (US)", value: "LcCChM6Garbhh5XtprmQ" },
      { label: "Aaron (US)", value: "ZEBslWM12xCQWILoQtiP" },
      { label: "JuniorDT (US)", value: "YqyBlFKvH9BLbkfNKw2j" },
      { label: "Brian (US)", value: "G0yjIg3xY8gEJZkHpjVm" },
      { label: "Nicola (US)", value: "8lh4p0JhUZdcRlkPwl1H" },
      { label: "Chelsea (US)", value: "NHRgOEwqx5WZNClv5sat" },
      { label: "Emily (US)", value: "VUGQSU6BSEjkbudnJbOj" },
      { label: "Evie (US)", value: "dvcWDtDpjMuyqdgVg3Hu" },

      { label: "Adrian (UK)", value: "v0RCLiw9p8Dhrblmk4YL" },
      { label: "Emmaline (UK)", value: "nDJIICjR9zfJExIFeSCN" },
      { label: "James (UK)", value: "lUTamkMw7gOzZbFIwmq4" },
      { label: "Jarvis (UK)", value: "4dkVKx8kDSvydWliVri5" },
      { label: "Busy Bea (UK)", value: "aHCytOTnUOgfGPn5n89j" },
      { label: "Abigail (UK)", value: "8z5UhJ1uv7X8TN5yg8oI" },
      { label: "Daria (UK)", value: "DUhzmIGFwXJ752SvgcCj" },

      { label: "Benji (NZ)", value: "wWUG72eEtupiUkpXafwX" },
      { label: "Paul (NZ)", value: "hp7ETPcMxGdsmsPtJd8I" },
      { label: "Sarn (NZ)", value: "JFZ2Sw5TN92wIBOEx7pZ" },
      { label: "Simon (NZ)", value: "yrB1fwuU6yTXnv5NFw3U" },
      { label: "Kylee (NZ)", value: "pcKdPWtbF6bM9o7NHjCI" },

      { label: "CS (AU)", value: "tWGXkYJGea4wMBN4mLD1" },
      { label: "Rachel McGrath (AU)", value: "paRTfYnetOrTukxfEm1J" },
      { label: "Baz (AU)", value: "mWNaiDAPDAx080ro4nL5" },
      { label: "Hannah (AU)", value: "M7ya1YbaeFaPXljg9BpK" },
      { label: "Alex (AU)", value: "dDpKZ6xv1gpboV4okVbc" },
      { label: "Jason (AU)", value: "mkrzc6Zmz8alRK0wX5dd" },
      { label: "Steve (AU)", value: "aGkVQvWUZi16EH8aZJvT" },
      { label: "Baz (AU)", value: "mWNaiDAPDAx080ro4nL5" },
      { label: "Abhi (AU)", value: "wONZP9eHujJUQu9Tfode" },
      { label: "Beatrice (AU)", value: "aCPFoFzFcLI23Rxnequ8" },
      { label: "Kristi (AU)", value: "y7jusIAhO4eJOzRUuKJX" },
    ],
  },
  {
    label: "Lmnt",
    value: "lmnt",
    isSpeed: false,
    voiceId: [
      { label: "lily", value: "lily" },
      { label: "daniel", value: "daniel" },
    ],
  },
  {
    label: "Neets",
    value: "neets",
    isSpeed: false,
    voiceId: [{ label: "vits", value: "vits" }],
  },
  {
    label: "Openai",
    value: "openai",
    isSpeed: false,
    voiceId: [
      { label: "alloy", value: "alloy" },
      { label: "echo", value: "echo" },
      { label: "fable", value: "fable" },
      { label: "onyx", value: "onyx" },
      { label: "nova", value: "nova" },
      { label: "shimmer", value: "shimmer" },
      { label: "ash", value: "ash" },
      { label: "ballad", value: "ballad" },
      { label: "coral", value: "coral" },
      { label: "sage", value: "sage" },
      { label: "verse", value: "verse" },
    ],
  },
  {
    label: "Playht",
    value: "playht",
    isSpeed: false,
    voiceId: [
      { label: "jennifer", value: "jennifer" },
      { label: "melissa", value: "melissa" },
      { label: "will", value: "will" },
      { label: "chris", value: "chris" },
      { label: "matt", value: "matt" },
      { label: "jack", value: "jack" },
      { label: "ruby", value: "ruby" },
      { label: "davis", value: "davis" },
      { label: "donna", value: "donna" },
      { label: "michael", value: "michael" },
    ],
  },
  {
    label: "Rime AI",
    value: "rime-ai",
    isSpeed: false,
    voiceId: [
      { label: "marsh", value: "marsh" },
      { label: "bayou", value: "bayou" },
      { label: "creek", value: "creek" },
      { label: "brook", value: "brook" },
      { label: "flower", value: "flower" },
      { label: "spore", value: "spore" },
      { label: "glacier", value: "glacier" },
      { label: "gulch", value: "gulch" },
      { label: "alpine", value: "alpine" },
      { label: "cove", value: "cove" },
      { label: "lagoon", value: "lagoon" },
      { label: "tundra", value: "tundra" },
      { label: "steppe", value: "steppe" },
      { label: "mesa", value: "mesa" },
      { label: "grove", value: "grove" },
      { label: "rainforest", value: "rainforest" },
      { label: "moraine", value: "moraine" },
      { label: "wildflower", value: "wildflower" },
      { label: "peak", value: "peak" },
      { label: "boulder", value: "boulder" },
      { label: "abbie", value: "abbie" },
      { label: "allison", value: "allison" },
      { label: "ally", value: "ally" },
      { label: "alona", value: "alona" },
      { label: "amber", value: "amber" },
      { label: "ana", value: "ana" },
      { label: "antoine", value: "antoine" },
      { label: "armon", value: "armon" },
      { label: "brenda", value: "brenda" },
      { label: "brittany", value: "brittany" },
      { label: "carol", value: "carol" },
      { label: "colin", value: "colin" },
      { label: "courtney", value: "courtney" },
      { label: "elena", value: "elena" },
      { label: "elliot", value: "elliot" },
      { label: "eva", value: "eva" },
      { label: "geoff", value: "geoff" },
      { label: "gerald", value: "gerald" },
      { label: "hank", value: "hank" },
      { label: "helen", value: "helen" },
      { label: "hera", value: "hera" },
      { label: "jen", value: "jen" },
      { label: "joe", value: "joe" },
      { label: "joy", value: "joy" },
      { label: "juan", value: "juan" },
      { label: "kendra", value: "kendra" },
      { label: "kendrick", value: "kendrick" },
      { label: "kenneth", value: "kenneth" },
      { label: "kevin", value: "kevin" },
      { label: "kris", value: "kris" },
      { label: "linda", value: "linda" },
      { label: "madison", value: "madison" },
      { label: "marge", value: "marge" },
      { label: "marina", value: "marina" },
      { label: "marissa", value: "marissa" },
      { label: "marta", value: "marta" },
      { label: "maya", value: "maya" },
      { label: "nicholas", value: "nicholas" },
      { label: "nyles", value: "nyles" },
      { label: "phil", value: "phil" },
      { label: "reba", value: "reba" },
      { label: "rex", value: "rex" },
      { label: "rick", value: "rick" },
      { label: "ritu", value: "ritu" },
      { label: "rob", value: "rob" },
      { label: "rodney", value: "rodney" },
      { label: "rohan", value: "rohan" },
      { label: "rosco", value: "rosco" },
      { label: "samantha", value: "samantha" },
      { label: "sandy", value: "sandy" },
      { label: "selena", value: "selena" },
      { label: "seth", value: "seth" },
      { label: "sharon", value: "sharon" },
      { label: "stan", value: "stan" },
      { label: "tamra", value: "tamra" },
      { label: "tanya", value: "tanya" },
      { label: "tibur", value: "tibur" },
      { label: "tj", value: "tj" },
      { label: "tyler", value: "tyler" },
      { label: "viv", value: "viv" },
      { label: "yadira", value: "yadira" },
    ],
  },
  {
    label: "Tavus",
    value: "tavus",
    isSpeed: false,
    voiceId: [{ label: "r52da2535a", value: "r52da2535a" }],
  },
];

export const WidgetIcons = [
  {
    id: 1,
    icon: () => <WidgetIcon1 />,
  },
  {
    id: 2,
    icon: () => <WidgetIcon2 />,
  },
  {
    id: 3,
    icon: () => <WidgetIcon3 />,
  },
  {
    id: 4,
    icon: () => <WidgetIcon4 />,
  },
  {
    id: 5,
    icon: () => <WidgetIcon5 />,
  },
  {
    id: 6,
    icon: () => <WidgetIcon6 />,
  },
];

export const widgetLink =
  "https://voxapp-api.qsstechnosoft.com/chat/assistant/fb59fb20-7bd8-48a7-844a-a3d65295bc24/widget-link";

export const ALL_FORM_FIELDS = [
  {
    id: uuidGenerator(),
    label: "First Name",
    type: "text",
    isDefault: true,
    required: true,
    visible: true,
    isFromAdd: true,
  },
  {
    id: uuidGenerator(),
    label: "Last Name",
    type: "text",
    isDefault: true,
    required: true,
    visible: true,
    isFromAdd: true,
  },
  {
    id: uuidGenerator(),
    label: "Email",
    type: "text",
    isDefault: true,
    required: true,
    visible: true,
    isFromAdd: true,
  },
  {
    id: uuidGenerator(),
    label: "Phone no",
    type: "phone",
    isDefault: true,
    required: true,
    visible: true,
    isFromAdd: true,
  },
];

export const ALL_FORM_ACTIONS = [
  {
    label: "Save contact",
    value: "createContact",
  },
  {
    label: "Call",
    value: "call",
  },
  {
    label: "Email",
    value: "email",
  },
];

export const FORM_COLOUMS = [
  {
    label: "First Name",
    key: "first_name",
    className: "profile",
  },
  {
    label: "Last Name",
    key: "last_name",
    className: "cellText",
  },
  {
    label: "Email",
    key: "email",
    className: "cellText",
  },
  {
    label: "Phone Number",
    key: "phone_no",
    className: "cellText",
  },
  {
    label: "Assistant Name",
    key: "assistantName",
    className: "cellText",
  },
  {
    label: "Share Date",
    key: "shareDate",
    className: "cellText",
  },
];

export const SOCIAL_URL = {
  facebook: "https://www.facebook.com/voxappai",
  x: "http://x.com/VoxAppAI",
  instagram: "https://www.instagram.com/voxappai",
  linkedin: "https://www.linkedin.com/company/voxapp-ai",
};

export const DEFAULT_MERGE_FIELDS = [
  {
    id: "default_1",
    updatedAt: "2025-02-05T11:54:16.000Z",
    createdAt: "2025-02-05T11:54:16.000Z",
    name: "{{first_name}}",
    label: "first_name",
  },
  {
    id: "default_2",
    updatedAt: "2025-02-05T11:54:16.000Z",
    createdAt: "2025-02-05T11:54:16.000Z",
    name: "{{last_name}}",
    label: "last_name",
  },
  {
    id: "default_3",
    updatedAt: "2025-02-05T11:54:16.000Z",
    createdAt: "2025-02-05T11:54:16.000Z",
    name: "{{email}}",
    label: "email",
  },
  {
    id: "default_4",
    updatedAt: "2025-02-05T11:54:16.000Z",
    createdAt: "2025-02-05T11:54:16.000Z",
    name: "{{phone_no}}",
    label: "phone_no",
  },
];

export const DefaultCSVColumns = [
  "firstName",
  "lastName",
  "phoneNumber",
  "countryCallingCode",
  "email",
];

export const ALL_CALLING_CODES = [
  "+61",
  "+64",
  "+91",
  "+44",
  "+353",
  "+33",
  "+1",
  "+49",
  "+39",
  "+34",
  "+351",
  "+43",
  "+41",
];

export const ALL_CALLING_CODES_WITH_FLAG = [
  { countryCode: "+44", country: "gb" },
  { countryCode: "+61", country: "au" },
  { countryCode: "+64", country: "nz" },
  { countryCode: "+91", country: "in" },
  { countryCode: "+353", country: "ie" },
  { countryCode: "+33", country: "fr" },
  { countryCode: "+1", country: "us" },
  { countryCode: "+1", country: "ca" },
  { countryCode: "+49", country: "de" },
  { countryCode: "+39", country: "it" },
  { countryCode: "+34", country: "es" },
  { countryCode: "+351", country: "pt" },
  { countryCode: "+43", country: "at" },
  { countryCode: "+41", country: "ch" },
];

export const PHONE_NUMBER_RULES = {
  "+44": { min: 9, max: 10, country: "gb" }, // UK
  "+61": { min: 9, max: 10, country: "au" }, // Australia
  "+64": { min: 7, max: 10, country: "nz" }, // New Zealand
  "+91": { min: 10, max: 10, country: "in" }, // India
  "+353": { min: 9, max: 10, country: "ie" }, // Ireland
  "+33": { min: 9, max: 10, country: "fr" }, // France
  "+1": { min: 10, max: 10, country: "us" }, // USA, Canada
  "+49": { min: 10, max: 12, country: "de" }, // Germany
  "+39": { min: 10, max: 10, country: "it" }, // Italy
  "+34": { min: 7, max: 9, country: "es" }, // Spain
  "+351": { min: 6, max: 9, country: "pt" }, // Portugal
  "+43": { min: 7, max: 12, country: "at" }, // Austria
  "+41": { min: 10, max: 10, country: "ch" }, // Switzerland
};

export const COUNTRY_CODE_MAP = {
  "+44": "gb",
  "+61": "au",
  "+64": "nz",
  "+91": "in",
  "+353": "ie",
  "+33": "fr",
  "+1": "us", // US and Canada share +1
  "+49": "de",
  "+39": "it",
  "+34": "es",
  "+351": "pt",
  "+43": "at",
  "+41": "ch",
};

export const PHONE_NUMBER_MASKS = {
  gb: "(..) ........",
  au: ". .... .....",
  nz: ".... ... ...",
  in: ".....-.....",
  ie: "(..) ... .....",
  fr: ". .. .. .. ...",
  us: "... ... ....",
  ca: "... ... ....",
  de: "(....) ........",
  it: "(...) ... ....",
  es: "... .. .. ..",
  pt: "... ... ...",
  at: "... .... .....",
  ch: "... ... ....",
};

export const TERMS_AND_CONDITIONS_URL =
  "https://www.voxapp.com/terms-conditions";

export const CARD_TYPES = [
  { name: "Visa", value: "visa" },
  { name: "MasterCard", value: "mastercard" },
  { name: "American Express", value: "amex" },
  { name: "Discover", value: "discover" },
  { name: "Diners Club", value: "diners" },
  { name: "JCB", value: "jcb" },
  { name: "UnionPay", value: "unionpay" },
  { name: "Maestro", value: "maestro" },
  { name: "Elo", value: "elo" },
  { name: "Mir", value: "mir" },
  { name: "RuPay", value: "rupay" },
  { name: "Troy", value: "troy" },
  { name: "Interac", value: "interac" },
  { name: "Cartes Bancaires", value: "cartesbancaires" },
];

export const INITIAL_ADD_ASSISTANT_DATA = {
  setup: {
    assistantType: "B2C",
    firstMessage: "",
    systemPrompt: "",
    emailAddress: [],
    sendSummary: true,
    sendSummaryToContact: false,
    pdfSummary: true,
    sendTranscript: false,
    sendRecording: false,
    summaryInstructions: "Summarise the Call",
    backgroundImage: "",
  },
  form: {
    formActions: ["createContact"],
    instructions: "",
    fields: ALL_FORM_FIELDS,
  },
  email: {
    subject: "",
    description: "",
  },
  voice: {
    assistantProvider: "openai",
    assistantModel: "gpt-4o-mini",
    transcriberProvider: "deepgram",
    transcriberModel: "nova-3",
    provider: "11labs",
    voice: "paul", // TODO: NEED TO CHANGE
    backgroundSound: "",
    language: "en",
    speed: 1,
    emotionRecognitionEnabled: true,
    endCallPhrases: "bye, bye bye, see ya, got to go, can't talk right now",
    voiceMailMessage: "",
    endCallMessage: "",
    isCustomVoiceId: false,
  },
  widget: {
    websites: [],
    widgetColor: "#0085DB",
    widgetColorOpacity: 100,
    widgetWidth: 100,
    widgetHeight: 80,
    desktopWidgetIcon: 1,
    desktopWidgetIconPosition: WIDGET_POSITION.BOTTOM_RIGHT,
    mobileWidgetIcon: 3,
    mobileWidgetIconPosition: WIDGET_POSITION.BOTTOM_RIGHT,
    headerBgColor: "#0085DB",
    headerBgColorOpacity: 100,
    headerTextColor: "#111",
    headerTextColorOpacity: 100,
    headerText: "",
    contentText: "",
    firstWidgetMessage: "",
    emailNotification: [],
    forwardingCountryCallingCode: "+91",
    forwardingPhoneNumber: "",
  },
  //Advanced Tab Data
  advanced: {
    callSettings: {
      backchanneling: false,
      backgroundDenoising: true,
      filterInjection: false,
      stability: 0,
      claritySimilarity: 0,
      styleExaggeration: 0,
      optimizeStreamingLatency: 0,
      hipaaCompliance: false,
      audioRecording: false,
      videoRecording: false,
      idleMessage: ["Are you still there?"],
      maxIdleMessage: 3,
      idleTimeout: 7.5,
      voiceMailMessage: "",
      endMailMessage: "",
    },
    startSpeakingSettings: {
      waitSeconds: 0.4,
      onPunctuationSeconds: 0.1,
      onNumberSeconds: 0.5,
      onNoPunctuationSeconds: 1.5,
      smartEndpoints: false,
    },
    endSpeakingSettings: {
      noOfWords: 0,
      voiceSeconds: 0.2,
      backOffSeconds: 1,
    },
    callTimeoutSettings: {
      silentTimeout: 10,
      maximumDuration: 1800,
    },
    functions: {
      enableEndCallFunctions: false,
      dialKeypad: false,
      countryCallingCode: "+61",
      phoneNumber: "",
      toolIds: [],
    },
  },
  phoneNumber: {
    fallbackDestinationCountryCode: "+61",
    fallbackDestinationPhoneNumber: "",
    inboundPhoneNumber: "",
    isPhoneNumberDefault: false,
    inboundPhoneNumberPrompt: "",
  },
  analysisPlan: null,
};

export const getVoiceFromStructuredData = (voiceType, accent, gender) => {
  const voiceMap = {
    Professional: {
      "American English": {
        male: "1SM7GgM6IMuvQlz2BwM3",
        female: "ZncGbt9ecxkwpmaX6V9z",
      }, // LcCChM6Garbhh5XtprmQ
      "British English": {
        male: "lUTamkMw7gOzZbFIwmq4",
        female: "nDJIICjR9zfJExIFeSCN",
      },
      Neutral: { male: "LcCChM6Garbhh5XtprmQ", female: "8lh4p0JhUZdcRlkPwl1H" },
      "Australian English": {
        male: "tWGXkYJGea4wMBN4mLD1",
        female: "paRTfYnetOrTukxfEm1J",
      },
      "New Zealand English": {
        male: "wWUG72eEtupiUkpXafwX",
        female: "pcKdPWtbF6bM9o7NHjCI",
      },
    },
    Friendly: {
      "American English": {
        male: "ZEBslWM12xCQWILoQtiP",
        female: "NHRgOEwqx5WZNClv5sat",
      },
      "British English": {
        male: "v0RCLiw9p8Dhrblmk4YL",
        female: "aHCytOTnUOgfGPn5n89j",
      },
      Neutral: { male: "LcCChM6Garbhh5XtprmQ", female: "8lh4p0JhUZdcRlkPwl1H" },
      "Australian English": {
        male: "mkrzc6Zmz8alRK0wX5dd",
        female: "wONZP9eHujJUQu9Tfode",
      },
      "New Zealand English": {
        male: "hp7ETPcMxGdsmsPtJd8I",
        female: "pcKdPWtbF6bM9o7NHjCI",
      },
    },
    Empathetic: {
      "American English": {
        male: "YqyBlFKvH9BLbkfNKw2j",
        female: "VUGQSU6BSEjkbudnJbOj",
      },
      "British English": {
        male: "4dkVKx8kDSvydWliVri5",
        female: "8z5UhJ1uv7X8TN5yg8oI",
      },
      Neutral: { male: "LcCChM6Garbhh5XtprmQ", female: "8lh4p0JhUZdcRlkPwl1H" },
      "Australian English": {
        male: "aGkVQvWUZi16EH8aZJvT",
        female: "aCPFoFzFcLI23Rxnequ8",
      },
      "New Zealand English": {
        male: "wWUG72eEtupiUkpXafwX",
        female: "pcKdPWtbF6bM9o7NHjCI",
      },
    },
    Humorous: {
      "American English": {
        male: "G0yjIg3xY8gEJZkHpjVm",
        female: "dvcWDtDpjMuyqdgVg3Hu",
      },
      "British English": {
        male: "4dkVKx8kDSvydWliVri5",
        female: "DUhzmIGFwXJ752SvgcCj",
      },
      Neutral: { male: "LcCChM6Garbhh5XtprmQ", female: "8lh4p0JhUZdcRlkPwl1H" },
      "Australian English": {
        male: "mWNaiDAPDAx080ro4nL5",
        female: "y7jusIAhO4eJOzRUuKJX",
      },
      "New Zealand English": {
        male: "wWUG72eEtupiUkpXafwX",
        female: "pcKdPWtbF6bM9o7NHjCI",
      },
    },
  };

  const defaultMaleVoiceId = "paul"; // default 11labs Male voice ID
  const defaultFemaleVoiceId = "ZncGbt9ecxkwpmaX6V9z"; // default 11labs Female voice ID

  const normalize = (str) => str?.toLowerCase().replace(/\s+/g, "");

  const accentMap = {
    american: "American English",
    british: "British English",
    neutral: "Neutral",
    australian: "Australian English",
    newzealand: "New Zealand English",
    "new zealand": "New Zealand English",
    americanenglish: "American English",
    britishenglish: "British English",
    australianenglish: "Australian English",
    newzealandenglish: "New Zealand English",
  };

  const normalizedVoiceType = Object.keys(voiceMap).find((key) =>
    normalize(key).includes(normalize(voiceType))
  );

  const normalizedAccent = accentMap[normalize(accent)];
  const normalizedGender = ["male", "female"].includes(normalize(gender))
    ? normalize(gender)
    : "male";

  if (normalizedVoiceType && normalizedAccent) {
    const genderVoiceId =
      voiceMap[normalizedVoiceType]?.[normalizedAccent]?.[normalizedGender];

    if (genderVoiceId) {
      return genderVoiceId;
    }

    // Fallback: search other genders in same accent group
    const accentVoices = voiceMap[normalizedVoiceType]?.[normalizedAccent];
    const anyVoiceId = accentVoices?.male || accentVoices?.female;

    if (anyVoiceId) {
      return anyVoiceId;
    }
  } else if (normalizedVoiceType) {
    // Fallback: search any accent in the same voice type
    const accentVoices = Object.values(voiceMap[normalizedVoiceType]).find(
      (voices) => voices[normalizedGender]
    );

    if (accentVoices && normalizedGender) {
      return accentVoices[normalizedGender];
    } else if (accentVoices) {
      const anyVoiceId = accentVoices?.male || accentVoices?.female;
      if (anyVoiceId) {
        return anyVoiceId;
      }
    }
  } else if (normalizedAccent) {
    // Fallback: search any voice type in the same accent
    const voiceTypes = Object.keys(voiceMap).find((key) =>
      Object.keys(voiceMap[key]).includes(normalizedAccent)
    );

    if (voiceTypes) {
      const genderVoiceId =
        voiceMap[voiceTypes]?.[normalizedAccent]?.[normalizedGender];

      if (genderVoiceId) {
        return genderVoiceId;
      }

      // Fallback: search other genders in same accent group
      const accentVoices = voiceMap[voiceTypes]?.[normalizedAccent];
      const anyVoiceId = accentVoices?.male || accentVoices?.female;

      if (anyVoiceId) {
        return anyVoiceId;
      }
    }
  }

  // Final fallback
  return normalizedGender == "female"
    ? defaultFemaleVoiceId
    : defaultMaleVoiceId;
};

export const PLAN_FEATURES = [
  {
    name: "Full System Access on Sign Up",
    value: "full_system_access",
    isChecked: false,
  },
  { name: "Try for Free", value: "try_for_free", isChecked: false },
  {
    name: "Assistant Templates",
    value: "assistant_templates",
    isChecked: false,
  },
  { name: "Campaign Groups", value: "campaign_groups", isChecked: false },
  { name: "Chat History", value: "chat_history", isChecked: false },
  {
    name: "Google Authentication",
    value: "google_authentication",
    isChecked: false,
  },
  {
    name: "Import Contacts with Form Builder",
    value: "import_contacts_with_form_builder",
    isChecked: false,
  },
  { name: "Outbound Calls", value: "outbound_calls", isChecked: false },
  {
    name: "Self-serve Knowledge Base",
    value: "self_serve_knowledge_base",
    isChecked: false,
  },
  {
    name: "Two-factor authentication",
    value: "two_factor_authentication",
    isChecked: false,
  },
  {
    name: "Multi-level permissions",
    value: "multi_level_permissions",
    isChecked: false,
  },
  { name: "Reporting", value: "reporting", isChecked: false },
  { name: "API Documentation", value: "api_documentation", isChecked: false },
  { name: "Call Forwarding", value: "call_forwarding", isChecked: false },
  { name: "Call Summary", value: "call_summary", isChecked: false },
  { name: "Custom Voices", value: "custom_voices", isChecked: false },
  { name: "Email", value: "email", isChecked: false },
  { name: "End Call Message", value: "end_call_message", isChecked: false },
  { name: "Inbound Calls", value: "inbound_calls", isChecked: false },
  {
    name: "Integrations (25,000 per month)",
    value: "integrations_25000_per_month",
    isChecked: false,
  },
  {
    name: "Knowledge Base for Call",
    value: "knowledge_base_for_call",
    isChecked: false,
  },
  { name: "Voicemail Message", value: "voicemail_message", isChecked: false },
  { name: "Web Calls", value: "web_calls", isChecked: false },
  { name: "Send Summary", value: "send_summary", isChecked: false },
  { name: "Hide Branding", value: "hide_branding", isChecked: false },
  {
    name: "Assistant Widget  for Web",
    value: "assistant_widget_for_web",
    isChecked: false,
  },
  { name: "Audio Recording", value: "audio_recording", isChecked: false },
  {
    name: "Calendar Integrations",
    value: "calendar_integrations",
    isChecked: false,
  },
  { name: "Custom Functions", value: "custom_functions", isChecked: false },
  {
    name: "Fine Tuning Assistant",
    value: "fine_tuning_assistant",
    isChecked: false,
  },
  { name: "HIPAA Compliance", value: "hipaa_compliance", isChecked: false },
  { name: "Multi Lingual", value: "multi_lingual", isChecked: false },
  {
    name: "Multiple Phone Numbers",
    value: "multiple_phone_numbers",
    isChecked: false,
  },
  {
    name: "Advanced reporting & analytics",
    value: "advanced_reporting_analytics",
    isChecked: false,
  },
  { name: "Enterprise support", value: "enterprise_support", isChecked: false },
  {
    name: "Enterprise-scale automations & integrations",
    value: "enterprise_scale_automations_integrations",
    isChecked: false,
  },
  {
    name: "Tailored onboarding",
    value: "tailored_onboarding",
    isChecked: false,
  },
];

export const AutomationToolsData = [
  {
    title: "Make.com",
    details:
      "You can seamlessly sync and manage events using triggers and actions to automate scheduling and updates across platforms",
    url: "https://make.com",
  },
  {
    title: "N8N.io",
    details:
      "N8n.io is an workflow automation tool that lets you connect apps and automate tasks. It supports over 350 integrations and allows custom code execution",
    url: "https://n8n.io/",
  },
];

export const FEATURE_TYPES = {
  0: "OUT_BOUND_CALL",
  1: "IN_BOUND_CALL",
  2: "ASSISTANT_TEMPLATES",
  3: "API_DOCUMENTATION",
  4: "ASSISTANT_WIDGET_FOR_WEB",
  5: "ADVANCED_REPORTING_ANALYTICS",
  6: "CAMPAIGN_GROUPS",
  7: "CALL_FORWARDING",
  8: "AUDIO_RECORDING",
  9: "ENTERPRISE_SUPPORT",
  10: "CHAT_HISTORY",
  11: "CALL_SUMMARY",
  12: "AUTOMATION",
  13: "ENTERPRISE_GRADE_SECURITY_GOVERNANCE",
  14: "GOOGLE_AUTHENTICATION",
  15: "CUSTOM_VOICES",
  16: "CALENDAR_INTEGRATIONS",
  17: "ENTERPRISE_SCALE_AUTOMATIONS_INTEGRATIONS",
  18: "IMPORT_CONTACTS_WITH_FORM_BUILDER",
  19: "EMAIL",
  20: "CUSTOM_FUNCTIONS",
  21: "TAILORED_ONBOARDING",
  22: "END_CALL_MESSAGE",
  23: "FINE_TUNING_ASSISTANT",
  24: "SELF_SERVE_KNOWLEDGE_BASE",
  25: "HIPAA_COMPLIANCE",
  26: "TWO_FACTOR_AUTHENTICATION",
  27: "INTEGRATIONS_250_ACTIONS_PER_MONTH",
  28: "INTEGRATIONS_25K_ACTIONS_PER_MONTH",
  29: "MULTI_LEVEL_PERMISSIONS",
  30: "KNOWLEDGE_BASE",
  31: "MULTI_LINGUAL",
  32: "REPORTING",
  33: "VOICEMAIL_MESSAGE",
  34: "VIDEO_RECORDING",
  35: "WEB_CALLS",
  36: "SEND_SUMMARY",
  37: "MULTIPLE_PHONE_NUMBERS",
  38: "HIDE_BRANDING",
};
